import { defined } from '../../common';

export default function hasValue(value) {
    return defined(value) && value !== null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/chart/utils/has-value.js
// module id = 373
// module chunks = 29